import React from "react";
import { ProgressBar as PB, Step } from "react-step-progress-bar";
import { generateKey } from "../../shared/utils";
import ProgressBarStep from "./ProgressBarStep";
import * as S from "./styles";
export var ProgressBar = function ProgressBar(_ref) {
  var e = _ref.steps,
      r = _ref.currentStep,
      s = _ref.goToStep,
      t = _ref.className,
      a = _ref.isDisabled,
      o = _ref.hasTopLabels,
      _ref$uid = _ref.uid,
      p = _ref$uid === void 0 ? generateKey() : _ref$uid;
  var c = 100 / (e.length - 1),
      l = r > 0 ? r * c : r;
  return React.createElement(S.Wrapper, {
    className: t,
    "data-testid": "progress-bar-" + p
  }, React.createElement(PB, {
    percent: l
  }, e.map(function (e) {
    return React.createElement(Step, {
      key: e
    }, function (_ref2) {
      var t = _ref2.accomplished,
          p = _ref2.index;
      return React.createElement(ProgressBarStep, {
        index: p,
        label: e,
        accomplished: t,
        currentStep: r,
        goToStep: s,
        isDisabled: a,
        hasTopLabels: o
      });
    });
  })));
};
ProgressBar.defaultProps = {
  isDisabled: !1,
  hasTopLabels: !1
};
export default ProgressBar;